import { name, version } from '../../package.json'

/** Single source of truth: package.json */
export const APP_NAME = name
export const APP_VERSION = version

export function formatAppVersion(appVersion = APP_VERSION) {
  return appVersion.startsWith('v') ? appVersion : `v${appVersion}`
}

export function getAppVersionLabel() {
  return formatAppVersion(APP_VERSION)
}
